import { TagsNetworkFilterBaseDataProvider } from './TagsNetworkFilterBaseDataProvider';
import { TagItem, TagsMethods } from '../../tagsManagerGrid/types';
import { gzTagsResponseMock } from '../../tagsManagerGrid/_mocks/responseMock';
import { ConsoleRequest, DataProviderType } from '../../../utils/request';

export class TagsNetworkFilterGzDataProvider extends TagsNetworkFilterBaseDataProvider {
  async getDataForView(companyIds: Array<string>): Promise<Array<TagItem>> {
    const payload = {
      limit: 100,
      page: 1,
      extraParams: {},
    };

    payload.extraParams = {
      companyId: companyIds,
    };

    const response = await ConsoleRequest.createRequest<any>({
      dataProviderType: DataProviderType.ENDPOINTS,
      payload,
      endpoint: 'GzTags',
      method: TagsMethods.READ_RECORDS,
    });

    return response.data;
  }
}
